import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item, permissions = [], currentUser }) => {
  const theme = useTheme();
  const canReceiveFax = currentUser.hasClinicFaxNumber;

  const referralNavItems = (menu, key) => {
    if (menu.tag === 'referrals') {
      if (permissions.filter(e => e.key === 'SCHEDULE_REFERRAL' && e.value).length > 0
        || permissions.filter(e => e.key === 'SEND_REFERRAL' && e.value).length > 0
        || permissions.filter(e => e.key === 'ACCEPT_REFERRAL' && e.value).length > 0) {
        return <NavItem key={key} item={menu} level={1} />;
      } else {
        return null;
      }
    }
    else if (menu.tag === 'send-referral') {
      if (permissions.filter(e => e.key === 'SEND_REFERRAL' && e.value).length > 0) {
        return <NavItem key={key} item={menu} level={1} />;
      } else {
        return null;
      }
    } else if (menu.tag === 'send-fax') {
      if (permissions.filter(e => e.key === 'SEND_REFERRAL' && e.value).length > 0) {
        return <NavItem key={key} item={menu} level={1} />;
      } else {
        return null;
      }
    } else if (menu.tag === 'fax') {
      if(canReceiveFax) {
        return <NavItem key={key} item={menu} level={1} />;
      }

    } else {
      return <NavItem key={key} item={menu} level={1} />;
    }
  };


  // menu list collapse & items
  const items = item.children?.map((menu, index) => {
    const key = `${item.id}-${index}`;
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={key} menu={menu} level={1} />;
      case 'item':
        return referralNavItems(menu, key);
      default:
        return (
          <Typography key={key} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
